import { AfterViewInit, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { DynamicTranslations } from 'src/locale/dynamicTranslations';
import { BetOutcomeResult, EventMappingType, HomeAway, TicketStatus } from 'src/app/models/enums';
import { IPlayedTicket } from 'src/app/models/ticket/playedTicket';
import { ITicketOrderingItem } from 'src/app/models/ticket/ticketOrderingItem';
import { TicketService } from 'src/app/services/ticket.service';
import { UtilityService } from 'src/app/services/util/utility.service';
import { ConstantValues } from 'src/app/models/util/constantValues';
import { SettingsService } from 'src/app/services/settings.service';
import { IPlayedTicketEvent } from 'src/app/models/ticket/playedTicketEvent';
import { EventsService } from 'src/app/services/events.service';
import { ModelMapperService } from 'src/app/services/util/model.mapper.service';
import { LocaleHelper } from 'src/locale/LocaleHelper';
import { StorageService } from 'src/app/services/util/storage.service';
import { ITicketItemGroup } from 'src/app/models/ticket/ticketItemGroup.interface';
import { ISystemOption } from 'src/app/models/ticket/system-option.interface';
import { IOddContainer } from 'src/app/components/ticket/oddContainer.interface';
import { ViewConfigurations } from 'src/app/models/util/viewConfigurations';
import { IWinningsPerHit } from 'src/app/models/ticket/winningsPerHit.interface';
declare var $: any;
@Component({
  selector: 'app-my-ticket-details',
  templateUrl: './my-ticket-details.component.html',
  styleUrls: ['./my-ticket-details.component.less']
})
export class MyTicketDetailsComponent implements OnInit, OnDestroy, AfterViewInit{


  playedTicket: IPlayedTicket;
  cket = null;
  // eslint-disable-next-line @typescript-eslint/naming-convention
  public CV = ConstantValues;
  public dynamicTranslations = DynamicTranslations;
  eventMappingTypeEnum = EventMappingType;
  public showSystemOptions = false;
  public taxBeforeStakeDefinitionPercent;
  private subscription: Subscription = new Subscription();
  public ticketStatusEnum = TicketStatus;
  public showPayoutInfos = false;
  public numberOfHits = 0;
  public languageCulture: string;
  private ticketItemGroups: { [eventId: number]: ITicketItemGroup } = {};
  private isMultiplaySystem: boolean;
  private isMultiplayBanker: boolean;
  private systemTicketItemGroups: ITicketItemGroup[] = [];
  private bankerTicketItemGroups: ITicketItemGroup[] = [];
  private hasLiveItems: boolean;
  private systemOptions: ISystemOption[] = [];
  private minOddsSysEvIdsByOddLowToHiWithoutBankers?: { [eventId: number]: number };
  private maxOddsSysEvIdsByOddHiToLowWithoutBankers?: { [eventId: number]: number };
  private oddsMap: { [eventId: number]: number } = {};
  private minOddsMap: { [eventId: number]: number } = {};
  public possibleWinForNumberOfHits: IWinningsPerHit[];
  private isFix: boolean;

  betOutcomeResultEnum = BetOutcomeResult;
  enumsHomeAway = HomeAway;


  @Input()
  ticketId: number;

  public orderingForTicketItemGroups: ITicketOrderingItem[] = [];

  constructor(
    private ticketService: TicketService,
    private utilityService: UtilityService,
    private settingsService: SettingsService,
    private storageService: StorageService,
    private modelMapper: ModelMapperService,
    private eventsService: EventsService) {
  }



  ngOnInit(): void {
    this.languageCulture = LocaleHelper.cultureName[this.storageService.language];

    this.subscription.add(this.ticketService.getTicketById(this.ticketId).subscribe(playedTicket => {
      this.playedTicket = playedTicket;
      if (!playedTicket) {
        return;
      }
      this.isFix = playedTicket.system === 'Fix' ? true : false;

      for (const event of playedTicket.events) {
        const ticketitemGroup = this.modelMapper.mapTicketItemGroupFromPlayedTicketEvent(event, this.isFix);
        this.ticketItemGroups[event.id] = ticketitemGroup;
        if (ticketitemGroup.isInBankersGroup || this.isFix) {
          this.bankerTicketItemGroups.push(ticketitemGroup);
          if (Object.keys(ticketitemGroup.ticketItems).length !== 1) {
            this.isMultiplayBanker = true;
          }
        } else {
          this.systemTicketItemGroups.push(ticketitemGroup);
          if (Object.keys(ticketitemGroup.ticketItems).length !== 1) {
            this.isMultiplaySystem = true;
          }
        }
        if (ticketitemGroup.isLive) {
          this.hasLiveItems = true;
        }
        const outcomeIds = event.outcomes.map(o => o.betOutcomeId);
        this.orderingForTicketItemGroups.push({ eventId: event.id, outcomeIds });

        this.setMinAndMaxOddMapsForTicketItemGroup(ticketitemGroup);
      }

      this.maxOddsSysEvIdsByOddHiToLowWithoutBankers = this.ticketService.createmaxOddsSysEvIdsByOddHiToLowWithoutBankers(this.ticketItemGroups, this.bankerTicketItemGroups.map(be => be.eventId), this.oddsMap);
      this.minOddsSysEvIdsByOddLowToHiWithoutBankers = this.ticketService.createminOddsSysEvIdsByOddLowToHiWithoutBankers(this.ticketItemGroups, this.bankerTicketItemGroups.map(be => be.eventId), this.minOddsMap);

      if (this.systemTicketItemGroups?.length > 0 && this.playedTicket.systemEventsInCombination.length > 0 && !this.hasLiveItems && ViewConfigurations.showNumberOfHitsForTicketSystem) {
        if (this.bankerTicketItemGroups?.length > 0) {
          this.systemOptions = this.ticketService.calculateMultiSystemOptions(this.isMultiplaySystem, this.isMultiplayBanker, this.systemTicketItemGroups, this.bankerTicketItemGroups);
        } else {
          this.systemOptions = this.ticketService.calculateRegularSystemOptions(this.ticketItemGroups, this.orderingForTicketItemGroups, this.isMultiplaySystem, this.systemTicketItemGroups, this.bankerTicketItemGroups);
        }

        for (const sysOpt of this.systemOptions) {
          if (this.playedTicket.systemEventsInCombination.includes(sysOpt.eventsInCombination)) {
            sysOpt.optionSelected = true;
          }
        }
        this.ticketService.updateOddsSystemOptions(this.systemOptions, this.orderingForTicketItemGroups, this.systemTicketItemGroups, this.bankerTicketItemGroups, this.oddsMap, this.minOddsMap, this.hasLiveItems, this.maxOddsSysEvIdsByOddHiToLowWithoutBankers ? this.maxOddsSysEvIdsByOddHiToLowWithoutBankers : [], this.minOddsSysEvIdsByOddLowToHiWithoutBankers ? this.minOddsSysEvIdsByOddLowToHiWithoutBankers : []);
        const data = this.ticketService.calculateOddsAndWinningsForUpdatedSystemOptions(this.systemOptions, null, [], [], 0, this.isFix, this.orderingForTicketItemGroups, playedTicket.stake / playedTicket.numberOfCombinations, playedTicket.stake, playedTicket.numberOfCombinations, playedTicket.payin, playedTicket.taxBeforeStake, !this.hasLiveItems && ViewConfigurations.showNumberOfHitsForTicketSystem, false);
        this.possibleWinForNumberOfHits = data.possibleWinForNumberOfHits;
        // this.possibleWinForNumberOfHits[this.possibleWinForNumberOfHits.length - 1].maxWinnings = playedTicket.possiblePayout;
      }

    }));
    //  this.subscription.add(this.settingsService.constantValuesLoaded$.subscribe(() => {
    if (ConstantValues.TAX_DEFINITIONS.taxBeforeStakeDefinition && ConstantValues.TAX_DEFINITIONS.taxBeforeStakeDefinition.stakePercent) {
      this.taxBeforeStakeDefinitionPercent = ConstantValues.TAX_DEFINITIONS.taxBeforeStakeDefinition.stakePercent;
    }
    // }));
  }

  setMinAndMaxOddMapsForTicketItemGroup(ticketitemGroup: ITicketItemGroup) {
    const eventOdds: IOddContainer = this.ticketService.getMInAndMaxOddForEvent(
      ticketitemGroup.eventId,
      Object.entries(ticketitemGroup.ticketItems).map(([k, ti]) => ({ outcomeId: ti.betOutcomeId, outcomeTypeId: ti.betTypeOutcomeId })),
      this.ticketItemGroups
    );

    this.oddsMap[ticketitemGroup.eventId] = eventOdds.maxOdd;
    this.minOddsMap[ticketitemGroup.eventId] = eventOdds.minOdd;
  }

  expandEvent(event: IPlayedTicketEvent) {
    if (!event.isLive && event.scores?.length > 0) {
      this.eventsService.expandEventResult(this.modelMapper.mapEventResultFromPlayedTicketEvent(event, this.languageCulture));

    }
  }

  get wagerPerBet() {
    if (this.playedTicket.numberOfCombinations > 0) {
      return this.playedTicket.stake / this.playedTicket.numberOfCombinations;
    }
    return 0;
  }

  get displayFormat(): string {
    return ConstantValues.DISPLAY_NUMBER_FORMAT_STRING_FOR_PIPE;
  }



  // calculateNumberOfHits(events: IPlayedTicketEvent[]) {
  //   // tslint:disable:prefer-for-of
  //   for (let i = 0; i < events.length; i++) {
  //     for (let j = 0; j < events[i].outcomes.length; j++) {
  //       if (+events[i].outcomes[j].status.code === 6) {
  //         this.numberOfHits++;
  //       }
  //     }
  //   }
  // }

  showResult(event) {

    if (!event.currentTarget.offsetParent.children[0].classList.contains('show')) {
      const obj = document.querySelectorAll('.result-expand');
      for (const iterator of Array.from(obj)) {
        iterator.classList.remove('show');
      }
    }
    event.currentTarget.offsetParent.children[0].classList.toggle('show');
  }

  ngAfterViewInit(): void {
    const interval = setInterval(() => {
      if ($('app-my-ticket-details .ticket-content-wrap .bet-type-name').length > 0) {
        $('app-my-ticket-details .ticket-content-wrap .bet-type-name').animate({ scrollLeft: 60}, 600);
        setTimeout(() => {
          $('app-my-ticket-details .ticket-content-wrap .bet-type-name').animate({ scrollLeft: 0}, 600);
        }, 600);
        clearInterval(interval);
      }
    }, 100);
  }

  getSportName(sportId: number) {
    return this.utilityService.getSportIcon(sportId);
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

}
